import { useState } from "react";
import axios from "axios";
import { Lock, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const GATE_TOKEN_KEY = "portfolio_gate_token";

export const Gate = ({ onUnlock }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/gate/verify`, { password });
      if (data?.success && data?.access_token) {
        sessionStorage.setItem(GATE_TOKEN_KEY, data.access_token);
        onUnlock(data.access_token);
      } else {
        setError("Incorrect password.");
      }
    } catch (err) {
      const status = err?.response?.status;
      if (status === 429) setError("Too many attempts. Please wait a minute.");
      else if (status === 401) setError("Incorrect password.");
      else if (!err?.response) setError("Cannot reach the server. Please try again.");
      else setError("Something went wrong. Please try again.");
    } finally {
      setBusy(false);
      setPassword("");
    }
  };

  return (
    <div
      data-testid="gate-overlay"
      className="grain fixed inset-0 z-[2000] flex items-center justify-center overflow-hidden bg-ink px-5"
    >
      <div className="orb bg-electric" style={{ width: 520, height: 520, top: "-10%", right: "-8%", opacity: 0.16 }} />
      <div className="orb bg-magenta" style={{ width: 460, height: 460, bottom: "-12%", left: "-6%", opacity: 0.14 }} />

      <form onSubmit={submit} className="glass relative w-full max-w-md rounded-3xl p-8 md:p-10">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/10 px-3 py-1 font-mono text-[0.65rem] uppercase tracking-[0.25em] text-electric">
          <Lock size={13} /> Private
        </span>
        <h1 className="mt-5 font-display text-3xl font-extrabold uppercase leading-[0.95] tracking-tighter text-cream md:text-4xl">
          Enter password to view the portfolio
        </h1>
        <p className="mt-3 font-body text-sm font-light leading-relaxed text-white/55">
          This portfolio is private. Please enter the password you were given to continue.
        </p>

        <div className="mt-8">
          <label className="mb-2 block font-mono text-[0.65rem] uppercase tracking-[0.2em] text-white/40">
            Password
          </label>
          <input
            data-testid="gate-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            autoComplete="current-password"
            className="w-full rounded-xl border border-white/10 bg-white/[0.02] px-4 py-3 font-body text-cream outline-none transition-colors focus:border-electric/60"
          />
        </div>

        {error && (
          <p data-testid="gate-error" role="alert" className="mt-3 font-body text-sm text-magenta">
            {error}
          </p>
        )}

        <button
          data-testid="gate-submit"
          type="submit"
          disabled={busy}
          className="group mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-cream py-4 font-semibold text-ink transition-colors hover:bg-electric disabled:opacity-60"
        >
          {busy ? "Checking…" : "Enter"}
          {!busy && <ArrowRight size={17} className="transition-transform group-hover:translate-x-0.5" />}
        </button>
      </form>
    </div>
  );
};
